import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function AdminBlockRoomDates() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState('');
  const [formData, setFormData] = useState({
    roomId: '',
    startDate: '',
    endDate: ''
  });

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const res = await api.get('/rooms');
        setRooms(res.data);
      } catch (err) {
        console.error('Failed to fetch rooms:', err);
      }
    };
    fetchRooms();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post(`/rooms/${formData.roomId}/block`, {
        startDate: formData.startDate,
        endDate: formData.endDate
      });
      alert('Room blocked! ' + res.data.message);
      setFormData({ roomId: '', startDate: '', endDate: '' });
    } catch (err) {
      console.error(err);
      alert('Failed to block room');
    }
  };

  const handleTestEmail = async () => {
    setLoading(true);
    setEmailStatus('');
    try {
      const res = await api.get('/bookings/check-gmail/');
      setEmailStatus(res.data.message || 'Email sent successfully!');
    } catch (err) {
      console.error(err);
      setEmailStatus('❌ Failed to send test email. Check backend or Gmail setup.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Block Room Dates</h2>

      <form onSubmit={handleSubmit}>
        <select
          name="roomId"
          value={formData.roomId}
          onChange={handleChange}
          required
        >
          <option value="">-- Select Room --</option>
          {rooms.map((room) => (
            <option key={room._id} value={room._id}>
              {room.name} (Capacity: {room.capacity})
            </option>
          ))}
        </select>

        <input
          type="date"
          name="startDate"
          value={formData.startDate}
          onChange={handleChange}
          required
        />
        <input
          type="date"
          name="endDate"
          value={formData.endDate}
          onChange={handleChange}
          required
        />

        <button type="submit">Block Dates</button>
      </form>

      <hr />

    
      <div style={{ marginTop: '20px' }}>
        <h3>Test notification Service</h3>
        <button onClick={handleTestEmail} disabled={loading}>
          {loading ? 'Sending...' : 'Send Test notification App'}
        </button>
        {emailStatus && (
          <p style={{ marginTop: '10px', color: emailStatus.includes('❌') ? 'red' : 'green' }}>
            {emailStatus}
          </p>
        )}
      </div>
    </div>
  );
}
